var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-trash fa-lg icon-button",attrs:{"title":"Desassociar Serviço"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarDesassociar(
                _vm.pagamentoComprometimento.pagamentoComprometimentoId
            )}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }